import { palette, definePreset } from "@primeuix/themes";
import Aura from "@primeuix/themes/aura";
import tenantPalette from "../../../../../signatus/resources/styles/palette.json";

const baseColor = "#230090";

const baseSurfaceColors = {
  0: "#ffffff",
  50: "{zinc.50}",
  100: "{zinc.100}",
  200: "{zinc.200}",
  300: "{zinc.300}",
  400: "{zinc.400}",
  500: "{zinc.500}",
  600: "{zinc.600}",
  700: "{zinc.700}",
  800: "{zinc.800}",
  900: "{zinc.900}",
  950: "{zinc.950}",
};

function getPreset(color: string, surfaceColors: object) {
  return {
    primitive: {
      gray: palette("#9E9E9E"), // draft state color
      amber: palette("#F97316"), // ready state color
      yellow: palette("#EAB308"), // in progress state color
      emerald: palette("#22C55E"), // final state color
      red: palette("#FF3D32"), // canceled state color
      sky: palette("#06B6D4"), // expired state color
      purple: palette("#A855F7"), // error state color
      bluegray: palette("#64748B"),
    },
    semantic: {
      primary: palette(color),
      colorScheme: {
        light: {
          surface: surfaceColors,
          primary: {
            color: "{primary.500}",
            contrastColor: "#ffffff",
            hoverColor: "{primary.600}",
            activeColor: "{primary.700}",
          },
          highlight: {
            background: "{primary.50}",
            focusBackground: "{primary.100}",
            color: "{primary.700}",
            focusColor: "{primary.800}",
          },
        },
      },
    },
  };
}

export function getTheme() {
  try {
    return definePreset(
      Aura,
      getPreset(
        tenantPalette?.primaryColor ?? baseColor,
        tenantPalette?.surface ?? baseSurfaceColors,
      ),
    );
  } catch (error) {
    console.warn("getTheme.warning: ", error);
  }

  return definePreset(Aura, getPreset(baseColor, baseSurfaceColors));
}
